import { render } from "./SectionStart.vue?vue&type=template&id=bef3500e"
import script from "./SectionStart.vue?vue&type=script&lang=js"
export * from "./SectionStart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\ar-esqrd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__